import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "@context/AuthContext";
import { PageLoading } from "@components/PageLoading";
import { routes } from "@/constants/routes";

export function ProtectedRoute() {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return <PageLoading />;
  }

  if (!isAuthenticated) {
    return <Navigate to={routes.home} replace />;
  }

  return <Outlet />;
}
